// @flow
import React from "react";
import bem from "@justpark/helpers/src/bem/bem";
import Typography from "../Typography";
import "./snackbar.scss";

type Props = {
  message: string,
  action: string,
  onClick?: (string) => void,
  hasError: boolean
};

const SnackBar = ({ message, action, onClick, hasError }: Props) => {
  const baseClass = "c-snackbar";

  return (
    <div className={bem(baseClass, null, { error: hasError })}>
      <Typography
        color="primary-inverse"
        size="primary"
        className={`${baseClass}__message`}
      >
        {message}
      </Typography>

      {action && (
        <Typography color="brand" size="primary">
          <button
            type="button"
            className={`${baseClass}__action`}
            onClick={onClick}
          >
            {action}
          </button>
        </Typography>
      )}
    </div>
  );
};

SnackBar.defaultProps = {
  action: "",
  onClick: () => {},
  hasError: false
};

export default SnackBar;
